import { GetMyUpcomingReservationsResponseDto } from "@/api/generated/generatedTypes";
import { formatReservationTime } from "@/utils/date";
import { Accordion, Box, Text } from "@mantine/core";

type Props = {
  reservation: GetMyUpcomingReservationsResponseDto;
};

const ReservationCardText = ({
  children,
  isCancelledReservation,
}: {
  children: React.ReactNode;
  isCancelledReservation: boolean;
}) => {
  return (
    <Text
      size="sm"
      c="white"
      style={{ textDecoration: isCancelledReservation ? "line-through" : "none" }}
    >
      {children}
    </Text>
  );
};

export function ReservationRequestedLocationAndTimes({ reservation }: Props) {
  const isCancelledReservation =
    reservation.status === "CANCELLED" || reservation.status === "CANCELLED_NO_REFUND";

  if (reservation.event) {
    return (
      <Box mt="xs">
        <ReservationCardText isCancelledReservation={isCancelledReservation}>
          {formatReservationTime(reservation.event.startTime)}
        </ReservationCardText>
        <ReservationCardText isCancelledReservation={isCancelledReservation}>
          {reservation.event.location.name}
        </ReservationCardText>
      </Box>
    );
  }
  const preferredTimes = reservation?.preferredTimes ?? [];
  const preferredLocationNames = reservation?.preferredLocationNames ?? [];

  if (preferredTimes.length === 1 && preferredLocationNames.length === 1) {
    return (
      <Box mt="xs">
        <ReservationCardText isCancelledReservation={isCancelledReservation}>
          {formatReservationTime(preferredTimes[0])}
        </ReservationCardText>
        <ReservationCardText isCancelledReservation={isCancelledReservation}>
          {preferredLocationNames[0]}
        </ReservationCardText>
      </Box>
    );
  }

  const getAdditionalTimesCount = () => {
    if (preferredTimes.length === 1) return "";
    return `+ ${preferredTimes.length - 1}일`;
  };

  const getAdditionalLocationsCount = () => {
    if (preferredLocationNames.length === 1) return "";
    return `+ ${preferredLocationNames.length - 1}곳`;
  };

  return (
    <Accordion
      styles={{
        control: {
          backgroundColor: "transparent",
          paddingLeft: 0,
          paddingRight: 0,
        },
        chevron: {
          color: "white",
        },
        item: {
          borderBottom: "none",
        },
        content: {
          padding: 0,
        },
      }}
    >
      <Accordion.Item value="1">
        <Accordion.Control>
          <ReservationCardText isCancelledReservation={isCancelledReservation}>
            {formatReservationTime(preferredTimes[0], {
              includeTime: false,
              includeWeekday: false,
            })}{" "}
            {getAdditionalTimesCount()}
          </ReservationCardText>
          <ReservationCardText isCancelledReservation={isCancelledReservation}>
            {preferredLocationNames[0]} {getAdditionalLocationsCount()}
          </ReservationCardText>
        </Accordion.Control>
        <Accordion.Panel>
          <Text c="white">요청 날짜</Text>
          {preferredTimes.map((time) => (
            <Text key={time} c="white" fw={800}>
              {formatReservationTime(time)}
            </Text>
          ))}

          <Text c="white" mt="md">
            요청 장소
          </Text>
          {preferredLocationNames.map((location) => (
            <Text key={location} c="white" fw={800}>
              {location}
            </Text>
          ))}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
